/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
//##########################################################################################
// 注意！
//
// 現在このファイルはts化中です。このファイルへ関数の追加は行わないでください。
// また関数を変更する場合は、util/**/*.util.tsに同じ関数があるので、そちらにも反映をおねがいします。
//##########################################################################################

const _ = require('lodash');
const Notification = require('./notification').default;

module.exports = {
  // 金額の文字列へ変換。
  // たとえば num が 3000 の時、"3,000" を返す。
  digits(num) {
    const type = typeof num;
    if (type !== 'number' && type !== 'string') {
      return null;
    }
    return num.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  },

  // UT済
  formatPrice(int) {
    if (int !== null) {
      return digits(int) + '円';
    }
  },

  // UT済
  formatPriceText(string) {
    if (string !== null) {
      return string.split(',').join('').trim();
    }
  },

  // UT済
  formatPriceWithMark(int) {
    if (int !== null) {
      return '¥' + digits(int);
    }
  },

  // 金額のレンジに合わせて「￥」マークを返す。
  // TODO: 使われてない。
  formatPriceWithRange(range) {
    if (range === null) {
      return '○○○○○';
    }

    range = parseInt(range, 10);
    if (range === 0) {
      return '○○○○○';
    } else if (range === 1) {
      return '○○○○○';
    } else if (range === 2) {
      return '○○○￥￥';
    } else if (range === 3) {
      return '○○￥￥￥';
    } else if (range === 4) {
      return '○￥￥￥￥';
    } else if (range === 5) {
      return '￥￥￥￥￥';
    } else {
      return '○○○○○';
    }
  },

  // UT済
  fetchCityName(lat, lng) {
    const params = {
      latlng: lat + ',' + lng,
      language: 'ja',
      key: 'AIzaSyD5SUOf50yWsZrP-EAxGrEgpQd2ZcsMkYA' // gitleaks:allow
    };
    return jsonPromise('https://maps.googleapis.com/maps/api/geocode/json', params);
  },

  // TODO: 使われてない
  fetchDistance(origin, dest) {
    return fetchDistanceMatrix([origin], [dest]).then(function (result) {
      const res = result.response;
      const seconds = dig(res, 'rows', 0, 'elements', 0, 'duration', 'value');
      if (seconds) {
        return Math.floor(seconds / 60) + '分';
      }
    });
  },

  // fetchDistanceからのみ使用される
  fetchDistanceMatrix(origins, destinations) {
    const service = new google.maps.DistanceMatrixService();
    const params = {
      origins,
      destinations,
      travelMode: google.maps.TravelMode.WALKING
    };

    return new Promise((resolve, reject) =>
      service.getDistanceMatrix(params, (response, status) => resolve({ response: response, status: status }))
    );
  },

  // UT済
  getParam(key) {
    return this.getParams()[key];
  },

  // UT済
  getParamInt(key) {
    const raw = this.getParam(key);
    if (!raw) {
      return null;
    }

    const parsed = parseInt(raw);
    if (isNaN(parsed)) {
      return null;
    }

    return parsed;
  },

  getParamMoment(key) {
    const raw = this.getParam(key);
    if (!raw) {
      return null;
    }

    const parsed = moment(raw);
    if (!parsed.isValid()) {
      return null;
    }

    return parsed;
  },

  // UT済
  // 表示中の画面のパラメーターをオブジェクトとして取得。
  getParams() {
    if (window.location) {
      if (_.isEmpty(window.location.search)) {
        return {};
      }
      const query = window.location.search.substring(1);
      const params = query.split('&');
      const results = {};
      for (var param of Array.from(params)) {
        var kv = param.split('=');
        var key = decodeURIComponent(kv[0]);
        var val = decodeURIComponent((kv[1] || '').replace(/\+/g, ' '));
        var from = key.indexOf('[');
        if (from === -1) {
          results[key] = val;
        } else {
          var to = key.indexOf(']');
          var index = decodeURIComponent(key.substring(from + 1, to));
          var subKey = decodeURIComponent(key.substring(to + 1));
          var subIndex = subKey.length > 0 ? /\[(.*?)\]/.exec(subKey)[1] : undefined;
          key = decodeURIComponent(key.substring(0, from));
          if (!results[key]) {
            results[key] = [];
          }
          if (!index) {
            results[key].push(val);
          } else {
            if (subIndex) {
              if (!results[key][index]) {
                results[key][index] = {};
              }
              results[key][index][subIndex] = val;
            } else {
              results[key][index] = val;
            }
          }
        }
      }
      return results;
    }
  },

  // UT済
  jsonPromise(url, args, method, timeout) {
    if (args == null) {
      args = {};
    }
    if (method == null) {
      method = 'get';
    }
    if (timeout == null) {
      timeout = 300000;
    }
    return new Promise((resolve, reject) =>
      $.ajax({
        url,
        data: args,
        method,
        dataType: 'json',
        timeout
      })
        .done(data => resolve(data))
        .fail(function (error) {
          if (!_handleAjaxError(error)) {
            return reject(error);
          }
        })
    );
  },

  // UT済
  calcDistance(lat1, lon1, lat2, lon2) {
    // ラジアンに変換
    const a_lat = (lat1 * Math.PI) / 180;
    const a_lon = (lon1 * Math.PI) / 180;
    const b_lat = (lat2 * Math.PI) / 180;
    const b_lon = (lon2 * Math.PI) / 180;

    // 緯度の平均、緯度間の差、経度間の差
    const latave = (a_lat + b_lat) / 2;
    const latidiff = a_lat - b_lat;
    const longdiff = a_lon - b_lon;

    // 子午線曲率半径
    // 半径を6335439m、離心率を0.006694で設定してます
    const meridian = 6335439 / Math.sqrt(Math.pow(1 - 0.006694 * Math.sin(latave) * Math.sin(latave), 3));

    // 卯酉線曲率半径
    // 半径を6378137m、離心率を0.006694で設定してます
    const primevertical = 6378137 / Math.sqrt(1 - 0.006694 * Math.sin(latave) * Math.sin(latave));

    // Hubenyの簡易式
    const x = meridian * latidiff;
    const y = primevertical * Math.cos(latave) * longdiff;

    return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
  },

  // UT済
  walkMinutesText(distanceMeter) {
    const minutes = Math.floor(distanceMeter / 70);
    return `${minutes}分`;
  },

  // TODO: つかってない
  selectPath() {
    const queryValue = this.cookie.get('query');
    const query = (() => {
      if (queryValue && queryValue.length > 0) {
        const queryArray = _.map(JSON.parse(queryValue), (value, key) => `${key}=${value}`);
        return '?' + _(queryArray).join('&');
      } else {
        return '';
      }
    })();
    return `/select${query}`;
  },

  // TODO: つかってない
  LinkedStateRadioGroupMixin: {
    radioGroup(key) {
      return {
        valueLink: value => {
          return {
            value: this.state[key] === value,
            requestChange: () => {
              const s = {};
              s[key] = value;
              return this.setState(s);
            }
          };
        }
      };
    }
  },

  // UT済
  snakeToCamel(str) {
    return str.replace(/_./g, s => s.charAt(1).toUpperCase());
  },

  // UT済
  camelToSnake(str) {
    return str.replace(/([A-Z])/g, s => '_' + s.charAt(0).toLowerCase());
  },

  // UT済
  snakeToCamelObject(object) {
    const res = {};
    for (var k in object) {
      var v = object[k];
      res[snakeToCamel(k)] = _.isNull(v) ? null : typeof v === 'object' ? snakeToCamelObject(v) : v;
    }
    return res;
  },

  // UT済
  camelToSnakeObject(object) {
    const res = {};
    for (var k in object) {
      var v = object[k];
      res[camelToSnake(k)] = _.isNull(v) ? null : typeof v === 'object' ? camelToSnakeObject(v) : v;
    }
    return res;
  },

  // UT済
  appendScript(url) {
    const e = document.createElement('script');
    e.charset = 'utf8';
    e.src = url;
    return document.body.appendChild(e);
  },

  // sendErrorObjectで使用されている
  sendError(params) {
    return $.ajax({
      url: '/errors.json',
      data: params,
      method: 'POST',
      dataType: 'json',
      timeout: 20000
    });
  },

  // UT済
  sendErrorObject(e) {
    sendError({
      message: e.message,
      stack: e.stack
    });
    if (typeof bugsnagClient !== 'undefined') {
      bugsnagClient.notify(e);
    }
    throw e;
  },

  // util内でのみ使われる
  zenToHan(str) {
    const hankaku = str.replace(/[！-～]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xfee0));
    return hankaku;
  },

  // UT済
  iOS() {
    const ua = navigator.userAgent;
    if (/iPhone/.test(ua) || /iPad/.test(ua) || /iPod/.test(ua)) {
      return true;
    } else {
      return false;
    }
  },

  // UT済
  dig(obj, ...keys) {
    for (var key of Array.from(keys)) {
      if (obj) {
        if (typeof obj[key] === 'function') {
          obj = obj[key]();
        } else {
          obj = obj[key];
        }
      } else {
        return null;
      }
    }
    return obj;
  },

  // TODO: つかってない
  stayDays(checkin, checkout) {
    return moment(checkout).diff(moment(checkin), 'days');
  },

  // TODO: つかってない
  daysInMonth(year, month) {
    const days = moment([year, month - 1, 1]).daysInMonth();
    return __range__(1, days, true);
  },

  // TODO: つかってない
  weekdaysInMonth(day, weekday) {
    const target = day.clone().startOf('month').day(weekday);
    if (target.date() > 7) {
      target.add(7, 'd');
    }
    const month = target.month();
    const days = [];
    while (month === target.month()) {
      days.push(target.clone());
      target.add(7, 'd');
    }
    return days;
  },

  // UT済
  validateEmail(email) {
    const r =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return r.test(email);
  },

  // UT済
  isAiTravel(id) {
    return parseInt(id) === 1;
  },
  // UT済
  isTabikobo(id) {
    return parseInt(id) === 2;
  },
  // UT済
  isMynavi(id) {
    return parseInt(id) === 3;
  },
  // UT済
  flightIconPath(name) {
    if (!name) {
      return;
    }

    const icons = [
      'AA',
      'AC',
      'AF',
      'AI',
      'AM',
      'AS',
      'AY',
      'B7',
      'BA',
      'BI',
      'BR',
      'CA',
      'CI',
      'CX',
      'CZ',
      'DL',
      'EK',
      'ET',
      'EY',
      'FM',
      'GA',
      'GS',
      'GW',
      'HA',
      'HO',
      'HU',
      'HX',
      'JL',
      'JQ',
      'KA',
      'KE',
      'KL',
      'LA',
      'LH',
      'LJ',
      'LO',
      'LX',
      'MF',
      'MH',
      'MI',
      'MU',
      'NH',
      'NX',
      'NZ',
      'OD',
      'OM',
      'OS',
      'OZ',
      'PG',
      'PK',
      'PR',
      'QF',
      'QR',
      'SA',
      'SC',
      'SK',
      'SL',
      'SQ',
      'SU',
      'TG',
      'TK',
      'TN',
      'TR',
      'TW',
      'UA',
      'UL',
      'UO',
      'VJ',
      'VN',
      'ZH',
      'ZU',
      '3U'
    ];
    // https://aitravel.atlassian.net/browse/AITRAVEL-1929
    const exceptionCodes = ['H1', 'B1'];
    const code = zenToHan(name)
      .replace(/[^a-zA-Z0-9]/g, '')
      .toUpperCase()
      .substr(0, 2);
    if (exceptionCodes.indexOf(code) !== 0) {
      if (icons.indexOf(code) === -1 && typeof bugsnagClient !== 'undefined') {
        return bugsnagClient.notify(new Error(`NO_ICON_ERROR: Icon of ${name} is not prepared`));
      } else if (exceptionCodes.indexOf(code) !== 0) {
        return `/images/flight_icons/${code}.png`;
      }
    }
  },
  // UT済
  flightClassIconPath(cabin) {
    if (!cabin) {
      return;
    }
    return `/images/flight_class_icons/${cabin}.png`;
  },
  // UT済
  flightClassName(cabin) {
    if (!cabin) {
      return;
    }
    switch (cabin) {
      case 'F':
        return 'ファーストクラス';
      case 'C':
        return 'ビジネスクラス';
      case 'W':
        return 'プレミアムエコノミークラス';
      case 'M':
        return 'エコノミークラス';
    }
  },

  // UT済
  sanitizePrice(int) {
    if (int === '') {
      return null;
    } else {
      const p = parseInt(zenToHan(int.toString()).replace(/[^-?\d]/g, ''));
      if (typeof p === 'number') {
        return p;
      } else {
        return null;
      }
    }
  },

  // UT済
  toParams(obj) {
    return _.map(obj, (v, k) => `${k}=${v}`).join('&');
  },

  renderRouterComponent(component, props) {
    return routeProps => React.createElement(component, _.merge(routeProps, props));
  },

  // UT済
  scrollToTop() {
    if (window) {
      return window.scrollTo(0, 0);
    }
  },

  // UT済
  compactObject(o) {
    const result = {};
    for (var k in o) {
      var v = o[k];
      if (!_.isEmpty(v)) {
        result[k] = v;
      }
    }
    return result;
  },

  // UT済
  // copyElementToClipBoardで呼ばれる
  copyToClipboard(showAlert) {
    if (showAlert == null) {
      showAlert = true;
    }
    document.execCommand('copy');
    if (showAlert) {
      return alert('クリップボードにコピーしました');
    }
  },

  // UT不可
  selectRange(el) {
    let sel;
    if (document.createRange && window.getSelection) {
      const range = document.createRange();
      sel = window.getSelection();
      sel.removeAllRanges();
      try {
        range.selectNodeContents(el);
        sel.addRange(range);
      } catch (error) {
        range.selectNode(el);
        sel.addRange(range);
      }
    }
    return sel;
  },

  // UT不可
  copyElementToClipBoard(el, showAlert) {
    if (showAlert == null) {
      showAlert = true;
    }
    if (document.createRange && window.getSelection) {
      selectRange(el);
      return copyToClipboard(showAlert);
    } else if (body.createTextRange) {
      const range = body.createTextRange();
      range.moveToElementText(el);
      range.select();
      return copyToClipboard(showAlert);
    }
  },

  // TODO: 使ってない
  // HTML貼り付け対応の是非でコピーの内容を変えられる
  copyHTMLAndTextToClipBoard(html, text, showAlert) {
    if (showAlert == null) {
      showAlert = true;
    }
    if (document.createRange && window.getSelection) {
      let listener;
      document.addEventListener(
        'copy',
        (listener = function (event) {
          event.preventDefault();
          event.clipboardData.setData('text/plain', selectRange(text).focusNode.innerText);
          event.clipboardData.setData('text/html', selectRange(html).focusNode.innerHTML);
          return document.removeEventListener('copy', listener);
        })
      );
      return copyToClipboard(showAlert);
    } else if (body.createTextRange) {
      const range = body.createTextRange();
      range.moveToElementText(html);
      range.select();
      return copyToClipboard(showAlert);
    }
  },

  _handleAjaxError(e) {
    const msg = e.responseJSON != null ? e.responseJSON.unallowed_ip_address : undefined;
    if (msg) {
      Notification.error(msg);
      location.reload();
      return true;
    }

    return false;
  },

  noop() {},

  cookie: require('cookie-cutter'),
  classnames: require('classnames'),
  moment: require('./lib/moment').default,
  _
};

function __range__(left, right, inclusive) {
  let range = [];
  let ascending = left < right;
  let end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}
